module.exports = __webpack_public_path__ + "afd4668b4f97c16879ae0575a1c6ecad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/goutte-plus.svg
// module id = 756
// module chunks = 0